import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import bemClassnames from 'react-bem-builder';
import PageTransition from '../components/page-transition';
import '../styles';

const cn = bemClassnames('page');

const Layout = ({ children }) => (
  <PageTransition cn={cn}>
    <Helmet>
      <link rel="shortcut icon" href="/favicon.ico" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="64x64" href="/favicon-64x64.png" />
      <link rel="icon" type="image/png" sizes="128x128" href="/favicon-128x128.png" />
    </Helmet>
    {children()}
  </PageTransition>
);

Layout.propTypes = {
  children: PropTypes.func
};

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js